var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoMin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "74px",
    height: "66px",
    viewBox: "0 0 74 66",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon white@3x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-HD-Copy",
    transform: "translate(-246.000000, -986.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-white",
    transform: "translate(248.000000, 988.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40,32 C40,47.5339806 40,56.1747573 40,57.9223301 C40,60.5436893 43.5483871,62 46.1290323,62 C48.7096774,62 51,60.9126214 51,58 C51,55.0873786 51,36 51,34 C51,32 54.3225806,32 55.1612903,32 C56,32 59,32 59,34.038835 C59,36.0776699 59,55.0873786 59,58 C59,60.9126214 61.6129032,62 64.1935484,62 C66.7741935,62 70,60.8349515 70,57.9223301 C70,55.9805825 70,47.3398058 70,32",
    id: "Line-Copy-16",
    transform: "translate(55.000000, 47.000000) rotate(-90.000000) translate(-55.000000, -47.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.13744873e-14,0 C3.57631911e-14,15.5339806 3.22179135e-14,24.1747573 5.07386542e-14,25.9223301 C7.84027068e-14,28.5436893 3.5483871,30 6.12903226,30 C8.70967742,30 12,28.8349515 12,25.9223301 C12,23.0097087 12,2.03883495 12,2.03883495 C12,2.03883495 12,0 15.1612903,0 C18.3225806,0 19,1.45631068 19,2.03883495 C19,2.62135922 19,23.0097087 19,25.9223301 C19,28.8349515 21.6129032,30 24.1935484,30 C26.7741935,30 30,28.8349515 30,25.9223301 C30,23.9805825 30,15.3398058 30,0",
    id: "Line-Copy-17"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMin);
export default __webpack_public_path__ + "static/media/logoMin.96f44e352777de17cb1f7ff184611703.svg";
export { ForwardRef as ReactComponent };